<template>
  <div class="report">
    <el-checkbox-group v-model="checkedReports">
      <el-row
        v-for="report in reports"
        :key="report.id"
        class="report__body"
        :gutter="10"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-col :span="2" class="report__body-checkbox">
          <el-checkbox :label="report.id" />
        </el-col>
        <el-col
          class="report__body-main"
          :span="2"
        >
          <router-link
            :to="{
              name: 'Report',
              params: { reportId: report.id, bidId: report.bid_id },
            }"
            class="main__link"
          >
            <div class="main__link-id">№&nbsp;{{ report.id }}</div>
            <div>{{ dateToFormat(report.created_at, 'onlyDateWithShortYear') }}</div>
            <div class="main__link-status">{{ showStatus(report.status) }}</div>
          </router-link>
        </el-col>
        <el-col class="report__body-user mod-gray" :span="3">
          {{ report.user_created_fio }}
        </el-col>
        <el-col class="report__body-info" :span="9">
          <div class="info__name">{{ report.name }}</div>
          <div class="info__customer">
            {{ report.client_short_name }}
          </div>
          <div class="info__dates">
            {{ dateToFormat(report.dates.from, 'shortDateWithoutYear') }} -
            {{ dateToFormat(report.dates.to, 'shortDateWithoutYear') }}
          </div>
          <div class="info__route">
            <span>{{ report.load_point && loadLocationFilter(report) }}</span>
            <span class="mod-gray">
              ({{ report.load_point && report.load_point.split(',')[0] }})
            </span>
            <span class="mod-divider">-</span>
            <span>{{ report.cargo_receiver }}</span>
            <span class="mod-gray">
              ({{ report.unload_point.split(',')[1].split(' ')[1] }})
            </span>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="report__body-digits">
            <div class="digits__title">Погружено: </div>
            <div class="digits__value">{{ formattedNumberDecimal(report.info.weight_ttn) }}</div>
            <div class="digits__title">Выгружено: </div>
            <div class="digits__value">{{ formattedNumberDecimal(report.info.weight_fact) }}</div>
            <div class="digits__title">Недовес: </div>
            <div :class="[ 'digits__value', nedoves(report)[0] === '-' ? 'mod-red' : 'mod-green']">
              {{ nedoves(report) }}
            </div>
          </div>
        </el-col>
        <el-col class="report__body-digits" :span="3">
          <div class="report__body-digits">
            <div class="digits__title">Сумма отчета:</div>
            <div class="digits__value">{{ formattedNumberDecimal(report.info.total_sum) }}</div>
            <div class="digits__title">Оплачено:</div>
            <div class="digits__value">{{ formattedNumberDecimal(report.info.total_paid) }}</div>
            <div class="digits__title">Вознаграждение:</div>
            <div class="digits__value mod-green">{{ formattedNumberDecimal(report.info.profit) }}</div>
          </div>
        </el-col>
        <el-col class="report__body-comments" :span="2">
          <i class="el-icon-s-comment comments__icon"  @click="showCommentsModal(report.id)" />
        </el-col>
      </el-row>
    </el-checkbox-group>
    <el-dialog
      :visible.sync="isCommentsOpen"
      width="70%"
      :modal-append-to-body="false"
      :show-close="false"
      class="comments"
      @close="closeCommentsModal"
    >
      <div class="comments__title">
        Комментарии к отчету:
      </div>
      <div>
        <loader-wrapper :loading="isCommentsLoading">
          <div v-if="reportComments.length" class="comments__content">
            <div v-for="(item, index) in reportComments" :key="index" class="comments__content-info">
              <div>
                <span class="info__date">{{ dateToFormat(item.created_at, 'respStatusDate') }}</span>
                <span class="info__user">{{item.user_created_fio}}</span>
              </div>
              <div class="info__text">{{ item.message }}</div>
            </div>
          </div>
          <div v-else class="comments__content">
            <div class="info__empty">К отчету нет комментариев</div>
          </div>
        </loader-wrapper>
        <el-input
          v-model="newComment"
          type="textarea"
          autosize
          resize="none"
          placeholder="Добавьте свой комментарий"
          class="comments__new"
        />
      </div>
      <span slot="footer">
        <el-button @click="isCommentsOpen = false">
          Закрыть
        </el-button>
        <el-button
          type="primary"
          :disabled="newComment.length === 0"
          @click="setNewComment"
        >
          Добавить комментарий
        </el-button>
      </span>
    </el-dialog>
  </div>
  </template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { formattedNumberDecimal } from '@/helpers/functions'
import { mapGetters, mapMutations } from 'vuex'
import { statusOptions } from '../../constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import shippingMixin from '@/mixins/shippingMixin'

const ReportsAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'Body',
  components: { LoaderWrapper },
  mixins: [shippingMixin],
  props: {
    reports: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isCommentsOpen: false,
      isCommentsLoading: false,
      newComment: '',
      commentedReportId: 0,
      reportComments: [],
      formattedNumberDecimal,
    }
  },
  computed: {
    ...mapGetters({
      checkedList: 'reports/getReportsPageChecked',
    }),
    checkedReports: {
      get() {
        return this.checkedList
      },
      set(list) {
        this.setCheckedList(list)
      },
    },
  },
  methods: {
    ...mapMutations({
      setCheckedList: 'reports/setReportsPageChecked',
    }),
    showStatus(value) {
      return statusOptions.find(item => (item.value) === value).label
    },
    nedoves(report) {
      let nedoves = Number(
        report.info.weight_fact - report.info.weight_ttn,
      ).toFixed(2)
      if (nedoves > 0) {
        nedoves = '+' + nedoves
      }

      return nedoves
    },
    // открытие модалки комментариев
    async showCommentsModal(id) {
      this.isCommentsOpen = true
      this.isCommentsLoading = true
      this.commentedReportId = id
      try {
        const { data } = await ReportsAPI.getReportComments(this.commentedReportId)
        this.reportComments = data
      } catch (e) {
        this.errHandler(e)
      } finally {
        this.isCommentsLoading = false
      }
    },
    // запись нового коммента
    async setNewComment() {
      this.isCommentsLoading = true
      try {
        const { data } = await ReportsAPI.addReportComment({
          total_report_id: this.commentedReportId,
          message: this.newComment,
        })
        try {
          const { data } = await ReportsAPI.getReportComments(this.commentedReportId)
          this.reportComments = data
        } catch (e) {
          this.errHandler(e)
        }
      } catch (e) {
        this.errHandler(e)
      } finally {
        this.isCommentsLoading = false
        this.newComment = ''
      }
    },
    closeCommentsModal() {
      this.isCommentsOpen = false
      this.commentedReportId = 0
      this.newComment = ''
      this.reportComments = []
    },
  },
}
</script>

<style lang="sass" scoped>
$red: #ea3323
$green: #56bb5c
$blue: #409EFF
$black: #1B1E24
$gray: #b7b7b7
::v-deep .el-checkbox-group
  font-size: inherit
.mod-gray
  color: $gray
.mod-green
  color: $green
.mod-red
  color: $red

.report
  &__body
    background-color: #fff
    padding-top: 18px
    padding-bottom: 18px
    margin-bottom: 20px
    min-height: 80px
    font-size: 14px

    &-checkbox
      text-align: center
      ::v-deep .el-checkbox__label
        display: none

    &-main
      text-align: center
      font-weight: bold
      line-height: 18px
      cursor: pointer
      .main__link
        color: $black
        &-id
          text-decoration: underline
          color: $blue
        &-status
          font-size: 12px
          font-weight: normal
          line-height: 1

    &-user
      color: $gray

    &-info
      line-height: 1.6
      .info__name, .info__dates
        font-weight: bold
      .info__customer
        font-weight: bold
      .info__dates
        font-weight: bold
      .info__route
        .mod-gray
          color: $gray
        .mod-divider
          margin: 0 5px

    &-digits
      padding: 0 10px
      .digits__title
        font-size: 12px
        text-align: left
      .digits__value
        margin-bottom: 2px
        text-align: right
        font-weight: bold

    &-comments
      text-align: center
      font-size: 30px
      color: $blue
      cursor: pointer

::v-deep .el-dialog__header
  display: none
.comments
  &__title
    margin-bottom: 20px
    font-size: 18px
    font-weight: bold
  &__content
    height: fit-content
    max-height: 300px
    overflow: auto
    padding: 20px
    background: #F9F9F9
    border: 1px solid $black
    border-radius: 4px
    &-info
      margin-bottom: 20px
      .info__date
        margin-right: 10px
        font-size: 12px
        font-weight: bold
        color: $blue
      .info__user
        font-size: 12px
      .info__text
        color: $black
        word-break: break-word
  &__new
    margin-top: 30px
</style>
